import { UserPermissions } from "@/entity/types/userPermissions";
import {
  Home,
  Wrench,
  Folder,
  FileText,
  MessageSquare,
  ShieldUser,
  Send,
  Info,
} from "lucide-react";
import { JSX } from "react";

// Types
interface Badge {
  text: string;
  variant: "primary" | "danger" | "warning" | "secondary";
}

interface SubItem {
  label: string;
  href: string;
  icon?: JSX.Element;
  badge?: Badge;
  permission?: keyof UserPermissions;
}

export interface MenuItem {
  id: string;
  label: string;
  icon: JSX.Element;
  href: string;
  badge?: Badge;
  subItems?: SubItem[];
  permission?: keyof UserPermissions;
  openInNewTab?: boolean;
}

export const menuItems: MenuItem[] = [
  {
    id: "home",
    label: "Tableau de bord",
    icon: <Home size={18} />,
    href: "/",
  },

  {
    id: "messages",
    label: "Messages",
    icon: <MessageSquare size={18} />,
    href: "/messages",
    permission: "Messagerie",
    badge: { text: "0", variant: "danger" },
  },

  {
    id: "comptes",
    label: "Comptes multiples",
    icon: <Wrench size={18} />,
    href: "/compte",
    permission: "MultiComptes",
  },

  {
    id: "relances",
    label: "Relances",
    icon: <Send size={18} />,
    href: "/tableau-de-bord",
    permission: "TableauDeBordRelances",
    subItems: [
      {
        label: "Tableau de bord",
        href: "/tableau-de-bord",
        permission: "TableauDeBordRelances",
      },
      {
        label: "Synthèse financière",
        href: "/synthese-financiere",
        permission: "SyntheseFinanciere",
      },
      {
        label: "Export comptable",
        href: "/export-comptable",
        permission: "ExportComptable",
      },
    ],
  },

  {
    id: "dossier",
    label: "Dossier",
    icon: <Folder size={18} />,
    href: "",
    permission: "NouveauDossier",
    subItems: [
      { label: "Nouveau", href: "/dossiers/nouveau" },
      { label: "Modification", href: "/dossiers/modification" },
    ],
  },

  {
    id: "reports",
    label: "Comptes rendu",
    icon: <FileText size={18} />,
    href: "",
    subItems: [
      { label: "Tous les dossiers", href: "/dossiers" },
      {
        label: "En cours", href: "/dossiers/consultation/en_cours",
      },
      {
        label: "Vérification bancaire", href: "/dossiers/consultation/verif_banquaire",
      },
      {
        label: "Terminés", href: "/dossiers/consultation/classes"
      },
    ],
  },

  {
    id: "admin",
    label: "Administrateur",
    icon: <ShieldUser size={18} />,
    permission: "Administrateur",
    href: "",
    subItems: [
      { label: "IP banni", href: "/Admin/GestionIp" },
      { label: "Activités Site", href: "/Admin/ActiviteesSite" },
      { label: "Reponse Probleme Utilisateur", href: "/Admin/EcranReponseProbleme" },
      { label: "Pdf", href: "/pdf" },
    ],
  },

  {
    id: "renseignement",
    label: "Renseignement Com.",
    icon: <Info size={18} />,
    permission: "RenseignementCommercial",
    href: "",
    subItems: [
      { label: "Faire une demande", href: "/demande-renseignement" },
    ],
  },

  // {
  //   id: "search",
  //   label: "Recherche",
  //   icon: <Search size={18} />,
  //   href: "",
  //   subItems: [
  //     { label: "Recherche avancée", href: "/search" },
  //     { label: "Historique", href: "" },
  //   ],
  // },


];